import { render, staticRenderFns } from "./EquipesLista.vue?vue&type=template&id=d31ecdd8&"
import script from "./EquipesLista.vue?vue&type=script&lang=js&"
export * from "./EquipesLista.vue?vue&type=script&lang=js&"
import style0 from "./EquipesLista.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports